export default {
      id: "social-linkedin-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#social-linkedin-usage",
      toString: function () {
        return this.url;
      }
    }